import { Badge } from "@mantine/core";
import React from "react";

export default function OutOfStockBadge({ children }) {
  return <Badge color="dark">{children || "Hết hàng"}</Badge>;
}
